<template>
  <div class="block-view">
    <label class="label">{{ label }}</label>
    <div class="slot-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    labelBackground: {
      type: String,
      default: "inherit",
    },
  },
};
</script>

<style lang="scss">
.block-view {
  border: 1px solid #e0e0e0;
  min-height: 55px;
  margin-bottom: 20px;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding-left: 15px;
  .label {
    position: absolute;
    font-size: 12px;
    top: -8px;
    left: 10px;
    background: v-bind(labelBackground);
    padding: 0 5px;
    color: #646161;
  }
}
</style>
